import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import { Subscription } from "rxjs";

import { SearchItems, SearchRequest } from "./search.datamodel";
import { SearchService } from "./search.service";
import { FormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SearchStoreModule } from './search-store.module';

/**
 * Component to search.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "ama-ng-search",
  standalone: true,
  imports: [
    FormsModule,
    NgbTooltip,
    SearchStoreModule
  ],
  providers: [SearchService],
  templateUrl: "search.component.html"
})
export class SearchComponent implements OnInit, OnDestroy {
  @Input() idSuffix!: string;
  @Output() searchTriggered: EventEmitter<any> = new EventEmitter();
  @ViewChild("searchInput", { static: true }) searchInput!: ElementRef;
  private searchRequestSubscriber!: Subscription;

  private readonly SEARCH_ITEMS_ENUM = SearchItems;
  private readonly SEARCH_KEYBIND = "/";

  constructor(
    private readonly searchService: SearchService
  ) {}

  ngOnInit() {
    this.searchRequestSubscriber = this.searchService
      .searchRequest$
      .subscribe(newSearchRequest => {
        if (Object.keys(newSearchRequest).length === 0) {
          this.searchInput.nativeElement.value = "";
        }
      });
    window.addEventListener("keydown",(e) => {
      if (e.ctrlKey && e.key === this.SEARCH_KEYBIND) {
        this.focusOnSearch(e);
      }
    });
  }

  /**
   * Focus the search component and select the content if it's present when the given key is pressed.
   * It also prevent the default action of the pressed key
   * @param key that has been pressed
   */
  focusOnSearch(key: KeyboardEvent) {
    key.preventDefault();
    this.searchInput.nativeElement.focus();
    if (this.searchInput.nativeElement.input !== "") {
      this.searchInput.nativeElement.select();
    }
  }

  ngOnDestroy() {
    this.searchRequestSubscriber.unsubscribe();
  }

  /**
   * Search.
   * @param input
   */
  search(input: string) {
    if (input !== '') {
      this.searchTriggered.emit([]);
      this.searchService.searchAction(
        new SearchRequest(
          input,
          this.SEARCH_ITEMS_ENUM.APPS
        )
      );
    } else {
      this.searchService.clearAction();
    }
  }
}
